import styled from 'styled-components'
// import BG from './assets/banner_sanduiche.jpg';
// import Equipe from './assets/equipe.jpg';
// import Metanoia from './assets/imagem-meta.jpg';

export const Site = styled.div`
  font-family: 'Inter', sans-serif;
  background: #222222;
  overflow: auto;
  color: #FFF;

  #nav-icon3 {
    width: 60px;
    height: 45px;
    position: relative;
    margin: 0px auto;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .5s ease-in-out;
    -moz-transition: .5s ease-in-out;
    -o-transition: .5s ease-in-out;
    transition: .5s ease-in-out;
    cursor: pointer;
  }

  #nav-icon3 span {
    display: block;
    position: absolute;
    height: 9px;
    width: 100%;
    background: #fff;
    border-radius: 9px;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .25s ease-in-out;
    -moz-transition: .25s ease-in-out;
    -o-transition: .25s ease-in-out;
    transition: .25s ease-in-out;
  }

  #nav-icon3 span:nth-child(1) {
    top: 0px;
  }
  
  #nav-icon3 span:nth-child(2),#nav-icon3 span:nth-child(3) {
    top: 18px;
  }
  
  #nav-icon3 span:nth-child(4) {
    top: 36px;
  }
  
  #nav-icon3.open span:nth-child(1) {
    top: 18px;
    width: 0%;
    left: 50%;
  }
  
  #nav-icon3.open span:nth-child(2) {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  
  #nav-icon3.open span:nth-child(3) {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  
  #nav-icon3.open span:nth-child(4) {
    top: 18px;
    width: 0%;
    left: 50%;
  }

  .fixed-tabs-whats {
    position: fixed;
    right: 0px;
    bottom: 30px;
    z-index: 100;

    @media(max-width: 900px) {
      display: none;
    }
  }

  .tab-whatsphone {
    background: #02b156;
    height: 60px;
    width: 70px;
    border-radius: 30px 0 0 30px;
    transition: 0.7s ease;

    &:hover {
      width: 280px;
      transition: 0.7s ease;
    }
  }

  .tab-whatsphone-icon {
    background-image: url(data:image/png;base64,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);
      background-repeat: no-repeat;
      width: 280px;
      height: 60px;
      background-size: 44px;
      background-position: 16px 7px;
      padding: 7px;
  }

  .tab-whatsphone-icon a {
    color: #ffffff;
    font-size: 14px;
    line-height: 11px;
    margin-left: 70px;
    text-decoration: none;
    font-family: sans-serif;
  }

  .tab-whatsphone-icon a strong {
    display: block;
    font-size: 18px;
    margin-left: 70px;
  }

  .glider-dot {
    background: #000;
    border: 1px solid #fff;
    color: #fff;
  }

  .glider-dot.active {
    background: #fff;
  }

  input {
    background-color: rgb(71, 71, 71);
    height: 37px;
    font-size: 18px;
    text-indent: 6px;
    border: 0;
    margin-bottom: 10px;
    outline: 0;
    color: rgb(180, 180, 180);
    width: 100%;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover, 
  input:-webkit-autofill:focus, 
  input:-webkit-autofill:active{
      -webkit-box-shadow: 0 !important;
  }

  header {
    background: #2f2f2f;

    -webkit-transition: all 0.5s ease;
    -moz-transition: position 10s;
    -ms-transition: position 10s;
    -o-transition: position 10s;
    transition: all 0.5s ease;

    @keyframes smoothScroll {
      0% {
        transform: translateY(-40px);
      }
      100% {
        transform: translateY(0px);
      }
    }

    &.fixed {
      z-index: 100;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      animation: smoothScroll 1s forwards;
    }
  }

  a {
    color: #fff;
    text-decoration: none;
    font-size: 14px;

    &:hover {
      text-decoration: underline;
    }
  }

  .slider--header .glider-contain {
    margin-bottom: -150px;

    @media(max-width: 900px) {
      margin-bottom: 0px;
    }
  }

  .slider--header .glider-dots {
    position: relative;
    left: -55px;
    top: -50px;

    @media(max-width: 900px) {
      left: 0;
      top: 0;
    }
  }

  #presenca {
    .glider-next, .glider-prev {
      top: 50%;
      margin-top: -23px;
    }

    @media(max-width: 900px) {
      
    }
  }
`

export const Center = styled.div`
  width: 1200px;
  margin: 0 auto;

  @media(max-width: 900px) {
    width: calc(100% - 20px);
    margin: 0 10px;
  }
`

export const Green = styled.span`
  color: #02b156;
`

export const Orange = styled.span`
  color: #f78734;
`

export const Head = styled.div`
  display: flex;
  justify-content: space-between;

  h1 {
    margin: 25px 0 20px;

    img {
      width: 230px;
    }
  }

  .mobile-menu {
    font-size: 50px;
    margin: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media(min-width: 900px) {
      display: none;
    }
  }

  #myLinks {
    display: none;
  }

  a {
    :hover {
      opacity: .9;
      text-decoration: none;
    }

    + a {
      margin-left: 30px;

      @media(max-width: 900px) {
        margin-left: 0;
      }
    }
  }
`

export const NAV = styled.nav`
  nav {
    padding-top: 50px;
    padding-bottom: 10px;
    text-transform: uppercase;
  }

  @media(max-width: 900px) {
    display: ${props => props.showMenu ? 'block' : 'none'};
    position: fixed;
    background: #2f2f2f;
    top: 95px;
    left: 0;
    padding: 10px;
    z-index:99;
    width: 100vw;

    nav {
      padding: 0;
      display: flex;
      flex-direction: column;

      a {
        font-size: 20px;
        padding: 10px 0;
        
        + a {
          border-top: 1px solid #000;
        }
      }
    }
  }
`;


export const HalfBox = styled.div`
  width: 45%;
  padding-top: 160px;
  padding-bottom: 50px;

  &.bigger {
    width: 55%;

    h2 {
      max-width: 590px;
    }
  }

  h2 {
    max-width: 500px;
  }

  @media(max-width: 900px) {
    padding-top: 80px;
    width: 100%;

    &.bigger {
      width: 100%;
    }
  }

  p {
    font-size: 21px;
  }
`

export const ButtonBox = styled.div`
  text-align: center;
  padding: 20px 0;
`

export const Banner = styled.div`
  background-size: cover;
  height: 500px;
  background-image: url('/assets/banner_sanduiche.webp');
  background-repeat: no-repeat;
  background-position: center center;
  position: relative;

`

export const CompanyList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;

  > div {
    width: 190px;
    height: 190px;
    background: #2f2f2f;
    margin-bottom: 20px;
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 10px;

    // + div {
    //   margin-left: 24px;
    // }
  }

`

export const SquareTitle = styled.h2`
  font-size: 40px;
  margin: 140px 0 40px;

  @media(max-width: 900px) {
    text-align: center;
  }

  ::before {
    content: "";
    display: inline-block;
    width: 30px;
    height: 30px;
    margin-right: 10px;
    background: #02b156;
  }
`;

export const Margin40 = styled.div`
  padding-bottom: 40px;
`

export const Transformation = styled.div`
@media(min-width: 1024px) {
  margin-top: 65px;
}

 &.black {
  background-color: #000;
 }

 h2 {
  font-size: 40px;
  margin: 0;

  ::before {
    content: "";
    display: inline-block;
    width: 30px;
    height: 30px;
    margin-right: 10px;
    background: #02b156;
  }

  &.orange {
    ::before {
      background: #f78734;
    }
  }
}
`

export const Leader = styled.div`
  padding-top: 80px;
  background: #000;

  h2 {
    text-align: center;
    font-size: 40px;
    margin: 0 0 18px;

    ::before {
      content: "";
      display: inline-block;
      width: 30px;
      height: 30px;
      margin-right: 10px;
      background: #f78734;
    }
  }

  p {
    text-align: center;
    font-size: 22px;

    &.title {
      font-size: 30px;
      color: #f78734;
      margin: 0 auto 28px;
    }

    &.description {
      max-width: 952px;
      margin: 0 auto;
    }
  }

  .footerTitle {
    max-width: 900px;
    margin: 53px auto 49px;
  }

  .cards {
    padding: 20px 0;

    h3 {
      margin: 0;
      padding: 20px 0 0;
      background: #000;
      color: #FFF;

      span {
        color: #f78734;
        font-size: 28px;
      }
    }
  }
`

export const Cards = styled.div`
  display: flex;
  color: #FFF;

  @media(max-width: 900px) {
    display: block;
  }  
`

export const Card = styled.div`
  background: #2f2f2f;
  flex: 1;
  position: relative; 

  + div {
    margin-left: 20px;

    @media(max-width: 900px) {
      margin-left: 0;
    }  
  }

  ul {
    list-style: none;
    list-style-position: inside;
    padding: 10px;
    padding-left: 34px;
    padding-bottom: 0;

    li {
      font-size: 16px;
      line-height: 30px;
      margin-bottom: 10px;
    }
  }

  ul li::before {
    content: "";
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 10px;
    background: #f78734;
    margin-left: -24px;
  }

  h3 {
    color: #f78734;
    text-align: center;
    font-weight: 500;

    @media(max-width: 900px) {
      padding-top: 20px;
    }
  }

  .bottom-box {
    position: absolute;
    bottom: 0;
    width: 100%;

    @media(max-width: 900px) {
      position: relative;
    }  
  }
`

export const Videos = styled.div`
  padding: 50px 0;

  &.nopadding {
    padding: 50px 0 0;
  }

  .video-frame {
    @media(max-width: 900px) {
      width: 100%;
      height: auto;
      min-height: 350px;
    }
  }

  .video-show {
    text-align: center;
  }

  .title {
    text-align: center;
    font-size: 20px;
    margin: 66px 0 52px;
  }

  .video-list {
    display:flex; /* added */
    justify-content:center; /* added */
    margin-bottom: 26px;
    padding: 20px;

    @media(max-width: 760px) {
      display: block;
      padding: 0;
      margin-bottom: 0;
    }
  }

  .video-items {
    + .video-items {
      margin-left: 30px;

      @media(max-width: 760px) {
        margin-left: 0;
      }
    }

    width: 250px;
    height: 110px;
    background: #f78734;
    cursor: pointer;
    display: flex;

    @media(max-width: 900px) {
      width: 100%;
      margin-bottom: 10px;
    }
    
    &:hover {
      opacity: .8;
    }

    img {
      width: 100px;
      height: 110px;
    }

    p {
      padding: 10px;
      margin: 0;
      font-size: 12px;
    }
  }
`

export const Team = styled.div`
  padding-top: 80px;
  background: #000;

  h2 {
    text-align: center;
    font-size: 40px;
    margin: 0;

    ::before {
      content: "";
      display: inline-block;
      width: 30px;
      height: 30px;
      margin-right: 10px;
      background: #f78734;
    }
  }

  .parallax {
    margin: 50px 0 0;
    background-image: url('/assets/equipe.webp');
    min-height: 200px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .meta {
    background-size: cover;
    height: 200px;
    background-attachment: fixed;
    background-image: url('/assets/imagem-meta.webp');
    background-repeat: no-repeat;
    background-position: center center;
    position: relative;

    @media(max-width: 900px) {
      display: none;
    }
  }
`